import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";

//Views
import PMTagsMain from "Modules/tags/views/main";

const RouterPMTags = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "pmtag") && <Route path="list" element={<PMTagsMain />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default RouterPMTags;